// TaskProgress.js
import React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 30,
    borderRadius: 20,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 20,
      backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
  }));

const TaskProgress = ({ progress }) => {
  return (
    <>
    
    <BorderLinearProgress variant="determinate" value={progress} />
    {/* <Typography variant="body2" color="textSecondary" component="div">
        {`${Math.round(progress)}%`}
    </Typography> */}

    </>
  );
}

export default TaskProgress;